/**************************************************
 * Nombre:       Formulario_Subir_Foto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoImagen from "../../Modulo_formularios/Componentes/IngresoImagen";

const Formulario_Subir_Foto = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={12}>
                    <IngresoImagen dato={'img'} {...props}

                    />
                </Grid>

            </Grid>

        </form>

    )

}
export default Formulario_Subir_Foto